import React, { useState } from 'react';
import './Features.css';

const featuresData = [
  {
    icon: '🤖',
    title: 'AI Code Generation',
    description: 'Generate complete functions, components, and modules using natural language prompts. UltraCoder AI understands context and writes production-ready code instantly.',
    tags: ['GPT-4', 'Context-Aware', 'Multi-Lang'],
    color: '#6366f1',
  },
  {
    icon: '🔍',
    title: 'Intelligent Code Review',
    description: 'Get real-time AI-powered code reviews that catch bugs, security vulnerabilities, and performance issues before they reach production.',
    tags: ['Security', 'Performance', 'Best Practices'],
    color: '#8b5cf6',
  },
  {
    icon: '⚡',
    title: 'Lightning-Fast Editor',
    description: 'Built on a blazing-fast engine with syntax highlighting for 30+ languages, smart autocomplete, and instant file navigation.',
    tags: ['30+ Languages', 'IntelliSense', 'Fast'],
    color: '#06b6d4',
  },
  {
    icon: '🤝',
    title: 'Real-Time Collaboration',
    description: 'Code together with your team in real time. Share sessions, review changes live, and communicate without leaving the editor.',
    tags: ['Live Share', 'Comments', 'Team Sync'],
    color: '#10b981',
  },
  {
    icon: '🔧',
    title: 'Smart Refactoring',
    description: 'AI-assisted refactoring tools that understand your entire codebase. Rename, restructure, and optimize code with confidence.',
    tags: ['Auto-Refactor', 'Type-Safe', 'AST'],
    color: '#f59e0b',
  },
  {
    icon: '🛡️',
    title: 'Security Scanner',
    description: 'Built-in OWASP security scanner that detects vulnerabilities, SQL injections, XSS, and other threats in your code in real time.',
    tags: ['OWASP', 'CVE Scan', 'Auto-Fix'],
    color: '#ef4444',
  },
  {
    icon: '🧪',
    title: 'AI Test Generator',
    description: 'Automatically generate comprehensive unit tests, integration tests, and E2E tests for your code with a single click.',
    tags: ['Jest', 'Vitest', 'Coverage'],
    color: '#ec4899',
  },
  {
    icon: '📊',
    title: 'Performance Profiler',
    description: 'Visual performance profiling integrated directly into your editor. Identify bottlenecks and optimize your code without external tools.',
    tags: ['Flamegraph', 'Memory', 'CPU'],
    color: '#14b8a6',
  },
  {
    icon: '🌐',
    title: 'Git Integration',
    description: 'Deep Git integration with AI-generated commit messages, smart merge conflict resolution, and visual diff viewer.',
    tags: ['GitHub', 'GitLab', 'Smart Merge'],
    color: '#f97316',
  },
];

const Features = () => {
  const [activeFeature, setActiveFeature] = useState(null);

  return (
    <section className="features" id="features">
      <div className="features__container">
        <div className="features__header">
          <div className="features__badge">⚡ Powerful Features</div>
          <h2 className="features__title">
            Everything you need to <br />
            <span className="features__title-gradient">build extraordinary software</span>
          </h2>
          <p className="features__subtitle">
            UltraCoder IDE packs AI capabilities, developer tools, and intelligent workflows
            into one seamless, powerful environment.
          </p>
        </div>

        <div className="features__grid">
          {featuresData.map((feature, index) => (
            <div
              key={index}
              className={`feature-card ${activeFeature === index ? 'feature-card--active' : ''}`}
              style={{ '--feature-color': feature.color }}
              onMouseEnter={() => setActiveFeature(index)}
              onMouseLeave={() => setActiveFeature(null)}
            >
              <div className="feature-card__icon">{feature.icon}</div>
              <h3 className="feature-card__title">{feature.title}</h3>
              <p className="feature-card__description">{feature.description}</p>
              <div className="feature-card__tags">
                {feature.tags.map((tag, i) => (
                  <span key={i} className="feature-card__tag">{tag}</span>
                ))}
              </div>
              <div className="feature-card__glow"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;